import React, { Component, ErrorInfo, ReactNode } from 'react';

import ErrorPage from './ErrorPage';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | undefined;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: undefined,
    errorInfo: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, errorInfo: null };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Eliminar console.error para evitar registrar información sensible en la consola
    // En un entorno de producción, aquí se podría implementar un servicio de registro
    // de errores seguro que no exponga información sensible
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  private handleReset = () => {
    this.setState({
      hasError: false,
      error: undefined,
      errorInfo: null,
    });
  };

  public render() {
    if (this.state.hasError) {
      return <ErrorPage error={this.state.error} resetError={this.handleReset} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
